import axiosInstance from "../utils/axios";
import { API_BASE_URL } from "../config/api.config";

export const notificationService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get("/notification", { params });
    return response.data;
  },
  fetchUnreadCount: async () => {
    const response = await axiosInstance.get("/notification/unread-count");
    return response.data;
  },
  markRead: async (uuid) => {
    const response = await axiosInstance.put(`/notification/${uuid}/read`);
    return response.data;
  },
  markAllRead: async () => {
    const response = await axiosInstance.put("/notification/read-all");
    return response.data;
  },
  streamUrl: () => `${API_BASE_URL.replace(/\/$/, "")}/notification/stream`,
};
